// BANEO · Avis texte — relative review dates and center-card highlight.
(function () {
  const DAY = 86400000;

  function plural(count, singular, pluralWord) {
    return count + ' ' + (count > 1 ? pluralWord : singular);
  }

  function relativeDate(isoDate) {
    const date = new Date(isoDate + 'T12:00:00');
    if (isNaN(date)) return null;
    const days = Math.floor((Date.now() - date.getTime()) / DAY);
    if (days < 1) return "Aujourd'hui";
    if (days < 7) return 'Il y a ' + plural(days, 'jour', 'jours');
    if (days < 30) return 'Il y a ' + plural(Math.floor(days / 7), 'semaine', 'semaines');
    if (days < 365) return 'Il y a ' + Math.floor(days / 30) + ' mois';
    return 'Il y a ' + plural(Math.floor(days / 365), 'an', 'ans');
  }

  function updateDates(root) {
    root.querySelectorAll('[data-baneo-date]').forEach((element) => {
      const text = relativeDate(element.dataset.baneoDate);
      if (text) element.textContent = text;
    });
  }

  const desktop = window.matchMedia('(min-width: 990px)');

  function highlightCenter(track) {
    const cards = Array.from(track.children);
    if (!desktop.matches) {
      cards.forEach((card) => card.classList.remove('is-active'));
      return;
    }
    const trackBox = track.getBoundingClientRect();
    const center = trackBox.left + trackBox.width / 2;
    let closest = null;
    let closestDistance = Infinity;
    cards.forEach((card) => {
      const box = card.getBoundingClientRect();
      const distance = Math.abs(box.left + box.width / 2 - center);
      if (distance < closestDistance) {
        closestDistance = distance;
        closest = card;
      }
    });
    cards.forEach((card) => card.classList.toggle('is-active', card === closest));
  }

  function init(root) {
    updateDates(root);
    root.querySelectorAll('.baneo-text-reviews__track').forEach((track) => {
      let frame = null;
      const schedule = () => {
        if (frame) return;
        frame = requestAnimationFrame(() => {
          frame = null;
          highlightCenter(track);
        });
      };
      track.addEventListener('scroll', schedule, { passive: true });
      window.addEventListener('resize', schedule);
      highlightCenter(track);
    });
  }

  init(document);
  document.addEventListener('shopify:section:load', (event) => init(event.target));
})();
